import { isPlatformBrowser } from '@angular/common';
import { Component, PLATFORM_ID, effect, inject, signal, viewChild } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { SidebarComponent } from './components/sidebar/sidebar';
import { HeaderComponent } from './components/header/header.component';
import { ToastComponent } from './components/toast/toast.component';
import { SongProfilePreviewDrawerComponent } from './components/song-profile-preview-drawer/song-profile-preview-drawer.component';
import { AlbumProfilePreviewDrawerComponent } from './components/album-profile-preview-drawer/album-profile-preview-drawer.component';
import { LayoutService } from './services/layout.service';
import { SongDrawerService } from './services/song-drawer.service';
import { AlbumDrawerService } from './services/album-drawer.service';

@Component({
  selector: 'app-root',
  imports: [
    RouterModule,
    RouterOutlet,
    SidebarComponent,
    HeaderComponent,
    ToastComponent,
    SongProfilePreviewDrawerComponent,
    AlbumProfilePreviewDrawerComponent
  ],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  protected readonly title = signal('client');

  protected readonly layoutService = inject(LayoutService);
  protected readonly songDrawerService = inject(SongDrawerService);
  protected readonly albumDrawerService = inject(AlbumDrawerService);
  private platformId = inject(PLATFORM_ID);
  readonly globalSongDrawer = viewChild<SongProfilePreviewDrawerComponent>('globalSongDrawer');
  readonly globalAlbumDrawer = viewChild<AlbumProfilePreviewDrawerComponent>('globalAlbumDrawer');

  constructor() {
    effect(() => {
      if (!isPlatformBrowser(this.platformId)) return;
      const open = this.layoutService.isSidebarOpen();
      document.documentElement.style.setProperty('--drawer-width', open ? '360px' : '0px');
    });

    effect(() => {
      const songId = this.songDrawerService.activeSongId();
      if (songId) {
        if (this.albumDrawerService.activeAlbumId() !== null) {
          this.albumDrawerService.close();
        }
        void this.globalSongDrawer()?.open(songId);
      } else {
        this.globalSongDrawer()?.closeSidebar();
      }
    });

    effect(() => {
      const albumId = this.albumDrawerService.activeAlbumId();
      if (albumId) {
        if (this.songDrawerService.activeSongId() !== null) {
          this.songDrawerService.close();
        }
        void this.globalAlbumDrawer()?.open(albumId);
      } else {
        this.globalAlbumDrawer()?.closeSidebar();
      }
    });
  }

  onGlobalDrawerOpenChange(open: boolean): void {
    if (!open && this.songDrawerService.activeSongId() !== null) {
      this.songDrawerService.close();
    }
  }

  onGlobalAlbumDrawerOpenChange(open: boolean): void {
    if (!open && this.albumDrawerService.activeAlbumId() !== null) {
      this.albumDrawerService.close();
    }
  }

  onAlbumTrackClick(songId: string): void {
    this.albumDrawerService.close();
    this.songDrawerService.open(songId);
  }
}
